import type { UiTheme } from './theme/uiTheme';
import { UI_THEMES } from './theme/uiTheme';

/** Canvas fill inside the export frame (not the app chrome). */
export const FREE_FORM_FRAME_FILL: Record<UiTheme, string> = {
  [UI_THEMES.LIGHT]: '#ffffff',
  [UI_THEMES.DARK]: '#000000',
};

/** Default new-text fill on solid free-form frames (contrast with frame fill). */
export const FREE_FORM_DEFAULT_TEXT_FILL: Record<UiTheme, string> = {
  [UI_THEMES.LIGHT]: '#000000',
  [UI_THEMES.DARK]: '#ffffff',
};

export const getFreeFormDefaultTextFill = (theme: UiTheme): string =>
  FREE_FORM_DEFAULT_TEXT_FILL[theme] ?? '#000000';

export const createSolidFrameBackground = (
  width: number,
  height: number,
  theme: UiTheme,
): string => {
  const w = Math.max(1, Math.round(width));
  const h = Math.max(1, Math.round(height));
  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return '';
  }
  ctx.fillStyle = FREE_FORM_FRAME_FILL[theme] ?? FREE_FORM_FRAME_FILL.dark;
  ctx.fillRect(0, 0, w, h);
  return canvas.toDataURL('image/png');
};

export default createSolidFrameBackground;
